<template>
<div class="space-y-12 bg-gray-100">

  <TtiHeader class="shadow-sm" :is-logged-in="false" />

  <div v-show="!showSearchPanel" class="mx-auto px-4 max-w-2xl">
    <p class="text-lg text-gray-900">
      <span class="mr-1">
        <span v-show="!hasSearchFinished">Searching for</span>
        <!-- <strong v-show="hasSearchFinished">{{ totalRecords }}</strong>  -->
        <span v-show="hasSearchFinished">Meet our</span>
        <strong v-if="$route.query.s"> {{ subjectName }}</strong>
        <strong v-if="!$route.query.s && $route.query.l"> {{ levelName }}</strong>
        <!-- tutor{{ totalRecords === 1 ? '' : 's' }}   -->
        tutors
        <!-- <span v-show="!hasSearchFinished"> who</span>
        teach -->
        <!-- <strong v-if="$route.query.s"> {{ subjectName }}</strong>  -->
        <!-- <span v-if="$route.query.s && $route.query.l">,</span> 
        <strong v-if="$route.query.l"> {{ levelName }}</strong>  -->
        teaching
        <strong v-if="$route.query.loc"> near you</strong>
        <span v-if="$route.query.loc && $route.query.o !== false"> and</span>
        <strong v-if="$route.query.o !== false"> online</strong>.
      </span>

      <button type="button" @click="showSearchPanel = true" class="text-sm text-blue-600 underline">Refine</button>
    </p>

    <toggle 
      v-if="$route.query.loc"
      v-model="includeTutorsWhoTeachOnline" 
      class="mt-4"
    >
      Include tutors who teach online
    </toggle>

    <!-- <toggle 
      :enabled="onlyShowTutorsWithEnhancedDbs" 
      @toggle="onlyShowTutorsWithEnhancedDbs = !onlyShowTutorsWithEnhancedDbs" 
      class="mt-4"
    >
      Only tutors with an Enhanced DBS check
    </toggle>

    <toggle 
      :enabled="onlyShowTutorsWithEnhancedDbs" 
      @toggle="onlyShowTutorsWithEnhancedDbs = !onlyShowTutorsWithEnhancedDbs" 
      class="mt-4"
    >
      Only tutors interviewed by The Tutor Index
    </toggle> -->
    
  </div>

  <SearchPanel 
    v-show="showSearchPanel"
    :subjectQuery="$route.query.subject"
    :levelQuery="$route.query.level"
    :locationNameQuery="$route.query.location"
    :locationLatLngQuery="{ lat: $route.query.lat, lng: $route.query.lat }"
    @onAfterSearchNavigation="executeSearch"
    class="mx-auto max-w-4xl"
  />

  <div v-if="!searchNotStarted" class="space-y-12">
    <p
      v-if="hasSearchFinished && totalRecords <= 0"
      class="text-2xl text-gray-400 font-medium text-center"
    >
      No results found.
    </p>
    <div v-if="hasSearchFinished" class="mx-auto max-w-2xl space-y-6">

      <!-- Total matches: {{ totalRecords }} -->

      <SearchResult 
        v-for="(result, index) in searchResults"
        :key="'result' + index" 
        :id="result.TutorsId"
        :name="result.TutorsName"
        :qualification="result.TutorsTopQualification"
        :rate="result.TutorsRateFrom === result.TutorsRateTo ? result.TutorsRateFrom : `${result.TutorsRateFrom}–${result.TutorsRateTo}`"
        :bio="result.TutorsBio"
        :favourited="$store.getters.isFavouriteTutor(result.TutorsId)"
        :teachesOnline="result.TeachesOnline"
        :location="result.TutorsLocation"
        :acceptsStripePayments="result.AcceptsStripePayments"
        :verifiedStatus="result.ValidDbsCheck ? 'DBS' : null"
        :isSubscriberOfPlus="result.IsSubscriberOfPlus"
        :testimonial="result.Testimonial"
        @toggleFavourite="$store.dispatch('toggleTutorAsFavourite', result.TutorsId)"
      />

      <div class="flex flex-col items-center space-y-4 p-6 bg-gray-200 text-center sm:rounded-lg sm:flex-row sm:items-start sm:space-x-4 sm:space-y-0 sm:text-left">
        <div class="flex-shrink-0 flex justify-center items-center w-20 h-20 border-2 border-gray-400 border-dotted rounded-full text-gray-400">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="question" class="w-10 h-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"></path></svg>  
        </div>
        <div>
          <div>
            <h2 class="text-lg text-gray-700 font-semibold leading-tight sm:inline">Can’t find a suitable tutor?</h2>
            <p class="text-gray-700 font-medium sm:inline sm:ml-1">Let us do the leg work for you.</p>
          </div>
          <p class="mt-1 text-sm text-gray-600">
            Tell us what you need and we’ll do our best to find you a suitable tutor.
          </p>
          <router-link :to="{ name: 'FindMeATutor' }" class="mt-3 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
            Find me a Tutor
          </router-link>
        </div>
      </div>

    </div>
    <div v-else class="mx-auto max-w-prose space-y-6">
      <div
        v-for="index of 3"
        :key="index"
        class="w-full h-40 bg-gray-200 animate-pulse sm:rounded-lg"
      ></div>
    </div>


    <div v-if="hasSearchFinished" class="flex justify-center items-start space-x-6 px-4">
      <button 
        v-if="currentPageNumber > 1"
        @click="$router.push({ name: 'SearchResults', query: { ...$route.query, p: currentPageNumber - 1 } })"
        class="flex flex-col items-end w-14 mt-0.5 text-blue-600"
      >
        <ChevronLeftIcon class="-mr-1.5 w-5 h-5" />
        <span class="text-sm text-gray-600">Previous</span>
      </button>
      <div v-else class="w-14"></div>
      <div class="flex -mx-2">
        <button 
          v-for="index of pageNumbersToShow"
          :key="index"
          @click="$router.push({ name: 'SearchResults', query: { ...$route.query, p: index } })"
          type="button"
          class="mx-2"
          :class="[
            (!$route.query.p && index === 1) || index === parseInt($route.query.p)
              ? 'text-gray-900 font-semibold'
              : 'text-blue-600 font-medium hover:underline',
            // This code decides to show/hide some of the numbers on mobile based upon
            // working out from the current page number. This means that even on mobile,
            // five buttons (if possible) should always be visible.
            { 'hidden sm:block': currentPageNumber - 2 - (2 - (totalNumberOfPages - currentPageNumber) < 0 ? 0 : 2 - (totalNumberOfPages - currentPageNumber)) > index || currentPageNumber + 2 + (3 - currentPageNumber < 0 ? 0 : 3 - currentPageNumber) < index }
          ]"
        >
          {{ index }}
        </button>
      </div>
      <button 
        v-if="currentPageNumber < totalNumberOfPages"
        @click="$router.push({ name: 'SearchResults', query: { ...$route.query, p: currentPageNumber + 1 } })"
        class="flex flex-col mt-0.5 w-14 text-blue-600"
      >
        <ChevronRightIcon class="-ml-1.5 w-5 h-5" />
        <span class="text-sm text-gray-600">Next</span>
      </button>
      <div v-else class="w-14"></div>
    </div>
    <div v-else class="flex justify-center space-x-4">
      <div
        v-for="index in 8"
        :key="index"
        class="w-6 h-6 bg-gray-200 rounded-md animate-pulse"
      ></div>
    </div>
  </div>

  <tti-footer />

</div>
</template>
<script>
  import { ChevronLeftIcon, ChevronRightIcon } from '@vue-hero-icons/solid'

  import TtiHeader from '@/prototype/HeaderNew.vue'
 
    import SearchPanel from '@/components/SearchPanel.vue'
    import SearchResult from '@/components/SearchResult.vue'
    import SearchService from '@/services/SearchServices'
    import Toggle from '@/components/Toggle.vue'

    const searchService = new SearchService();

    export default {
        components: {
          TtiHeader,
          'tti-footer': () => import('../prototype/Footer.vue'),
          SearchPanel,
          SearchResult,
          ChevronLeftIcon,
          ChevronRightIcon,
          Toggle,
        },
        data() {
            return {
              searchNotStarted: false,
                hasSearchFinished: false,
                searchResults: [],
                totalRecords: 0,
                resultsPerPage: 10,
                searchService,
                subjectName: null,
                levelName: null,
                showSearchPanel: false,
                onlyShowTutorsWithEnhancedDbs: false,
                includeTutorsWhoTeachOnline: true
            }
        },
        watch: {
          '$route.query'() {
            this.executeSearch()
            this.showSearchPanel = false
          },
          includeTutorsWhoTeachOnline(newVal) {
            this.$router.push({ name: 'SearchResults', query: { ...this.$route.query, o: newVal } })
          }
        },
        methods: {
            executeSearch() {
              this.searchNotStarted = false
              this.hasSearchFinished = false
              
              this.getSearchResults().then((response) => {
                  this.searchResults = response.results;
                  this.totalRecords = response.total;
                  this.hasSearchFinished = true;
              })

              if (this.$route.query.s) {
                searchService.getSubjectById(this.$route.query.s).then(response => {
                  this.subjectName = response.data.Description
                })
              }

              if (this.$route.query.l) {
                searchService.getLevelById(this.$route.query.l).then(response => {
                  this.levelName = response.data.Description
                })
              }

              this.includeTutorsWhoTeachOnline = this.$route.query.o ?? true
            },
            getSearchResults() {
              const subjectId = this.$route.query.s
              const levelId = this.$route.query.l
              const latitude = this.$route.query.lt
              const longitude = this.$route.query.lg
              const pageNumber = this.$route.query.p
              const learnOnline = this.$route.query.o
              const studentPreparedToTravel = this.$route.query.w
              const distanceStudentWillTravel = this.$route.query.d
              const tutorsName = this.$route.query.n
              const mustAcceptStripe = this.$route.query.op // online payments
              const mustHavePassedDbsCheck = this.$route.query.dbs
              const residesIn = this.$route.query.r

              return searchService.getSearchResults(
                subjectId,
                levelId,
                { lat: latitude, lng: longitude },
                pageNumber,
                learnOnline,
                studentPreparedToTravel,
                distanceStudentWillTravel,
                tutorsName,
                mustAcceptStripe,
                mustHavePassedDbsCheck,
                residesIn,
              )
              .then((response) => {
                return response.data;   
              });
            }
        },
        computed: {
          totalNumberOfPages() {
            return Math.ceil(this.totalRecords / this.resultsPerPage)
          },
          currentPageNumber() {
            return parseInt(this.$route.query.p) || 1
          },
          pageNumbersToShow() {
            const totalPageNumbersToShow = 10

            var result = []

            result.push(this.currentPageNumber)

            // This code loops through the maximum number of pages available (which could be hundreds)
            // and figures out which numbers to show, up to the totalPageNumbersToShow. So by default
            // it would show 1 through 10, but could show 7 through 16 if page 11 was selected, or similarly
            // 22 through 31 with page 31 being the last page (any could be selected between 26 and 31)
            for (let index = 1; index < totalPageNumbersToShow; index++) {
              if (this.currentPageNumber - index > 0 && result.length < totalPageNumbersToShow) result.splice(0, 0, this.currentPageNumber - index)
              if (this.currentPageNumber + index <= this.totalNumberOfPages && result.length < totalPageNumbersToShow) result.push(this.currentPageNumber + index)
            }

            return result
          }
        },
        mounted() {
          if (Object.keys(this.$route.query).length === 0) {
            this.searchNotStarted = true
            this.hasSearchFinished = true
            this.showSearchPanel = true
          }
          else {
            this.executeSearch()
          }
        }
    }

</script>